<div *ngIf="dataFieldTaxonomies" class="container-general d-flex flex-wrap">
    <ng-container *ngFor="let dataFieldTaxonomy of dataFieldTaxonomies; let idxTaxonomies = index;">
        <div class="container-general__item flex-custom-{{typeOfContent}}" style="padding: 16px;">
            <p class="text-neutral-50 ls-label-small-bold text-uppercase"
               [ngClass]="{'text-center': dataFieldTaxonomies.length == 1}"
               [innerHTML]="dataFieldTaxonomy.titolo | translate">
            </p>
            <div class="">
                <ng-container *ngIf="dataFieldTaxonomy.isArray && !dataFieldTaxonomy.date">
                    <div class="d-flex flex-wrap" [ngClass]="{'justify-content-center': dataFieldTaxonomies.length == 1}">
                        <p class="mb-1 me-2 text-neutral-30 ls-p-small"
                           *ngFor="let data of dataFieldTaxonomy.value; let idxTaxonomy = index;"
                           [innerHTML]="data.displayName">
                        </p>
                    </div>
                </ng-container>
                <ng-container *ngIf="!dataFieldTaxonomy.isArray && !dataFieldTaxonomy.date">
                    <p class="mb-1 me-2 text-neutral-30 ls-p-small" [ngClass]="{'text-center': dataFieldTaxonomies.length == 1}"
                    [innerHTML]="dataFieldTaxonomy.translate ? (dataFieldTaxonomy.value | translate) : dataFieldTaxonomy.value">
                    </p>
                </ng-container>
                <ng-container *ngIf="!dataFieldTaxonomy.isArray && dataFieldTaxonomy.date">
                    <p *ngIf="!hour" class="mb-1 me-2 text-neutral-30 ls-p-small" [ngClass]="{'text-center': dataFieldTaxonomies.length == 1}">
                        {{ dataFieldTaxonomy.value | localizedDate: dataFieldTaxonomy.date }}
                    </p>
                    <div *ngIf="hour" class="d-flex flex-wrap">
                        <p class="mb-1 me-2 text-neutral-30 ls-p-small">{{ dataFieldTaxonomy.value | localizedDate: dataFieldTaxonomy.date }}</p>
                        <p class="mb-1 me-2 text-neutral-30 ls-p-small">{{ '- ' + ("BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.AT" | translate) + hour }}</p>
                    </div>
                </ng-container>
            </div>
        </div>
    </ng-container>
</div>